import { produce } from "../../../../../../../libs/immer";
export var inputEmailUseCase = function inputEmailUseCase(result, setState) {
  setState(function (prev) {
    return produce(prev, function (draft) {
      var _draft$scenario;
      if (((_draft$scenario = draft.scenario) === null || _draft$scenario === void 0 ? void 0 : _draft$scenario.type) !== 'email') return;
      draft.scenario.emailInput.errorMessage = '';
      draft.scenario.emailInput.value = result !== null && result !== void 0 ? result : '';
    });
  });
};